{
    "common": {
        "or": "ou",
        "logo_alt": "Logo",
        "loading": "Chargement",
        "internet_restored": "Connexion Internet rétablie",
        "internet_lost": "Connexion Internet perdue",
        "new_version_available": "Une nouvelle version de l'application est disponible. L'application sera mise à jour dans 10 secondes.",
        "app_updated": "Application mise à jour vers la dernière version."
    },
    "login": {
        "welcome": "Comment souhaites-tu te connecter ?",
        "no_account": "Nouveau sur Medendo ?",
        "start_trial_link": "Commence ton essai gratuit",
        "finish_setup_message": "Ton compte est prêt. Connecte-toi pour terminer la configuration de l'authentification à deux facteurs.",
        "email_step": {
            "email_label": "Saisissez votre adresse e-mail",
            "next_button": "Suivant",
            "invalid_email": "Adresse e-mail invalide"
        },
        "refer_to_email_step": {
            "message": "Un e-mail a été envoyé à : <1>{{email}}</1><2/><3/>Suivez les instructions dans votre e-mail<4/>Vous pouvez fermer cette fenêtre."
        },
        "mfa_step": {
            "title": "Saisissez le code de vérification",
            "code_label": "Code de vérification",
            "verify_button": "Vérifier",
            "no_code_button": "Je ne trouve pas le code",
            "error_expired": "Le code a expiré. Veuillez réessayer.",
            "error_incorrect": "Le code est incorrect. Veuillez réessayer."
        },
        "mfa_setup_step": {
            "title": "Configuration de l'authentification multifacteur",
            "setup_error": "Une erreur s'est produite lors de la configuration TOTP. Veuillez réessayer.",
            "verification_error": "Le code de vérification est incorrect. Veuillez réessayer.",
            "finalize_error": "La vérification a réussi, mais la connexion a échoué. Veuillez réessayer.",
            "scan_instruction": "Scannez ce QR Code avec votre application d'authentification :",
            "manual_entry_instruction": "Ou saisissez le code ci-dessous manuellement :",
            "code_input_instruction": "Saisissez le code de vérification :",
            "code_label": "Code de vérification",
            "verify_button": "Vérifier"
        },
        "password_step": {
            "title": "Mot de passe",
            "password_label": "Saisissez votre mot de passe",
            "login_button": "Se connecter",
            "forgot_password_button": "Mot de passe oublié ?",
            "error_invalid_password": "Mot de passe invalide. Veuillez réessayer.",
            "error_mfa_verify": "Une erreur s'est produite lors de la vérification de votre compte.",
            "error_send_email": "Une erreur s'est produite lors de l'envoi de l'e-mail.",
            "error_send_reset_email": "Erreur lors de l'envoi de l'e-mail",
            "reset_email_sent": "Un e-mail de réinitialisation du mot de passe a été envoyé.",
            "sso_hint": "Votre compte utilise la connexion Google ou Microsoft. La connexion par mot de passe et la récupération de mot de passe ne sont pas disponibles.",
            "welcome_verify_email": "Bienvenue sur Medendo ! 🚀 Nous allons d'abord vous envoyer un <strong>e-mail</strong> pour que vous puissiez définir votre propre mot de passe.",
            "send_email_button": "Envoyer l'e-mail"
        }
    },
    "account_disabled": {
        "title": "Ton compte a été désactivé",
        "message": "Tu n'as plus accès à Medendo.\nSi tu penses qu'il s'agit d'une erreur, contacte la personne responsable de la connexion avec le système Medendo.",
        "logout_button": "Se déconnecter"
    },
    "signup": {
        "title": "Crée ton compte",
        "subtitle": "Commence ton essai gratuit sur Medendo",
        "email_label": "Saisis ton adresse e-mail",
        "password_label": "Choisis un mot de passe",
        "invalid_email": "Adresse e-mail invalide",
        "weak_password": "Le mot de passe doit contenir au moins {{min}} caractères",
        "password_hint": "Au moins {{min}} caractères",
        "send_code_button": "Envoyer le code de vérification",
        "code_sent": "Nous avons envoyé un code à 6 chiffres à {{email}}. Saisis-le ci-dessous.",
        "redirecting_to_checkout": "E-mail vérifié, redirection vers le paiement en cours...",
        "completing": "Finalisation de ton compte...",
        "complete_expired": "Ce lien de paiement a expiré ou n'a pas été finalisé. Recommence.",
        "code_label": "Code de vérification",
        "verify_code_button": "Vérifier",
        "invalid_code": "Ce code est incorrect ou a expiré",
        "resend_code": "Renvoyer le code",
        "resend_cooldown": "Renvoyer dans {{seconds}}s",
        "wrong_email": "Mauvaise adresse e-mail ? Recommence",
        "email_verified": "{{email}} est vérifié - termine maintenant ton compte",
        "create_button": "Créer le compte",
        "account_exists": "Tu as déjà un compte avec cette adresse e-mail. Connecte-toi plutôt.",
        "already_completed": "Ton compte est déjà configuré. Connecte-toi plutôt.",
        "unavailable": "L'inscription n'est pas disponible pour le moment. Reviens bientôt.",
        "have_account": "Tu as déjà un compte ?",
        "go_to_login": "Connecte-toi",
        "error_generic": "Une erreur s'est produite lors de l'inscription. Réessaie.",
        "checkout_cancelled": "Le paiement a été annulé. Tu peux réessayer quand tu veux.",
        "rate_limited": "Trop de tentatives. Attends un instant et réessaie.",
        "retry_button": "Réessayer",
        "first_name_label": "Prénom",
        "last_name_label": "Nom",
        "name_required": "Saisis ton prénom et ton nom",
        "toggle_password_visibility": "Afficher ou masquer le mot de passe"
    },
    "encounter": {
        "offline_too_long": "Hors ligne trop longtemps, l'enregistrement s'est arrêté. Cliquez sur le bouton « régénérer » pour créer un rapport.",
        "undo": "Annuler",
        "redo": "Rétablir",
        "name": "Nom",
        "menu_record": "Nouvelle consultation",
        "menu_history": "Historique",
        "menu_templates": "Modèles",
        "menu_admin": "Admin",
        "menu_settings": "Paramètres",
        "menu_open": "Menu",
        "menu_close": "Fermer le menu",
        "menu_integrations": "Intégrations",
        "menu_support": "Assistance",
        "report": "Rapport",
        "report_field_empty": "Rien de noté",
        "transcript_empty_title": "Pas encore de transcription",
        "transcript_empty_body": "Lance l'enregistrement : la conversation s'affiche ici au fil de l'échange",
        "report_empty_title": "Pas encore de rapport",
        "report_empty_body": "Arrête l'enregistrement : le rapport est rédigé à partir de la conversation",
        "report_empty_body_no_permission": "Ton compte ne peut pas créer de rapports ici",
        "report_generating_body": "Rédaction du rapport à partir de la conversation…",
        "transcript": "Transcription",
        "template": "Modèle",
        "logout": "Déconnexion",
        "logout_confirm_title": "Se déconnecter ?",
        "logout_confirm_body": "Tu seras déconnecté(e) sur cet appareil et renvoyé(e) à l'écran de connexion.",
        "logout_confirm": "Se déconnecter",
        "customer_portal": "Vers le portail client",
        "customer_portal_error": "Un problème est survenu à l'ouverture du portail client. Réessaie.",
        "conversation_not_available": "Cette conversation n'est plus disponible.",
        "loading": "Chargement...",
        "select_patient": "Sélectionner un client",
        "client_locked_by_assistant": "Cette consultation est liée à {{name}}. Pour travailler avec un autre client, commence une nouvelle consultation.",
        "client_locked_by_assistant_unnamed": "Cette consultation est liée à un client. Pour travailler avec un autre client, commence une nouvelle consultation.",
        "switch_to_patient_search": "Revenir à la recherche de client",
        "no_patients_found": "Aucun client trouvé",
        "no_patient": "Aucun client - saisir un nom",
        "patient_id_duplicate_hint": "L'identifiant du client est affiché lorsque le nom et la date de naissance ne sont pas uniques.",
        "no_templates_message": "Vous avez besoin d'un modèle pour démarrer une consultation",
        "no_templates_subtitle": "Choisissez-en un ci-dessus, ou créez-en un dans les Modèles.",
        "no_templates_action": "Voir les modèles",
        "no_care_plan_templates": "Aucun modèle disponible pour ce client",
        "care_plan_templates_load_error": "Impossible de charger les modèles pour ce client. Veuillez réessayer.",
        "care_plan_template_resolve_error": "Impossible de charger le modèle sélectionné. Veuillez réessayer.",
        "in_person": "En personne",
        "online": "En ligne",
        "meeting_type": "Type d'entretien",
        "start": "Démarrer l'enregistrement",
        "stop": "Arrêter l'enregistrement",
        "recording": "Enregistrement...",
        "resume": "Reprendre",
        "leave_while_recording_title": "Enregistrement en cours",
        "leave_while_recording": "Tu es encore en train d'enregistrer. Quitter cette page et arrêter l'enregistrement ?",
        "sticky_panel": "Panneau d'enregistrement flottant",
        "copied": "Copié",
        "unknown": "inconnu",
        "submit_confirmation_title": "Confirmer l'envoi",
        "submit_confirmation_content": "Ce rapport sera envoyé à « {{adapter}} »{{patientName}}, êtes-vous sûr(e) ?",
        "for_patient": " pour le client « {{name}} »",
        "select_patient_first": "Veuillez d'abord sélectionner un client",
        "send_report_to_adapter": "Envoyer le rapport à {{adapter}}",
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "audio_errors": {
            "access_denied": "Medendo n'a pas pu accéder à la source audio",
            "invalid_source": "La source sélectionnée ne peut pas être utilisée comme entrée audio. Choisis une autre source, s'il te plaît.",
            "no_mic_found": "Aucun microphone trouvé sur ton appareil. Vérifie si ton microphone est connecté et réessaie",
            "mic_fallback_to_default": "Ton microphone sélectionné n'a pas été trouvé. Le microphone par défaut est utilisé à la place. Choisis-en un autre si besoin.",
            "tab_capture_failed": "Aucun audio ne peut être capturé pour l'onglet sélectionné. Tu as peut-être choisi le mauvais onglet (aucune piste audio disponible), ou le navigateur bloque la capture audio de l'onglet sélectionné.",
            "mic_not_supported": "Ce navigateur ne permet pas d'accéder au microphone, Medendo ne peut donc pas enregistrer ici. Ouvre Medendo dans un autre navigateur et réessaie.",
            "start_recording_error": "Une erreur s'est produite lors du démarrage de l'enregistrement.",
            "upload_failed": "Erreur lors du chargement du fragment audio {{number}}",
            "low_audio_level": "Le niveau audio est faible depuis un moment. Vérifie ton microphone.",
            "recording_not_capturing": "Rien n'est enregistré depuis plusieurs minutes. Vérifie ton microphone et relance l'enregistrement.",
            "recording_stopped_early": "Un fragment d'enregistrement s'est arrêté plus tôt que prévu. Vérifie la transcription pour des lacunes.",
            "audio_source_lost_microphone": "Le microphone ne fonctionne plus. Medendo reprendra l'enregistrement automatiquement dès qu'il sera reconnecté.",
            "audio_source_recovered_microphone": "Le microphone est de nouveau connecté. L'enregistrement continue automatiquement.",
            "audio_source_lost_screen": "L'onglet partagé n'envoie plus d'audio. Partage à nouveau l'onglet et relance l'enregistrement.",
            "audio_source_interrupted_microphone": "Le microphone a été interrompu. Une autre application l'utilise peut-être.",
            "audio_source_interrupted_screen": "L'audio de l'onglet partagé a été interrompu. Vérifie que l'onglet est toujours en lecture et partagé.",
            "audio_source_added": "Un nouveau microphone a été connecté. Il n'est pas utilisé pour cet enregistrement. Arrête et relance l'enregistrement pour en changer.",
            "recording_error": "Une erreur d'enregistrement s'est produite.",
            "start_recording_failed": "Échec du démarrage de l'enregistrement.",
            "session_start_failed": "Impossible de démarrer une session d'enregistrement audio. Vérifie ton micro et/ou mets à jour ton navigateur.",
            "upload_missing": "Aucun fichier chargé.",
            "no_transcription": "Aucune transcription reçue.",
            "transcription_failed": "La transcription a échoué."
        },
        "copy_transcript_tooltip": "Copier le texte de la transcription dans le presse-papiers",
        "copy_transcript": "Copier la transcription",
        "modify_report_tooltip": "Cela vous permet d'apporter des modifications à l'ensemble du rapport",
        "modify_report": "Modifier le rapport",
        "modify_item_tooltip": "Cela permet d'apporter des modifications à cet élément du rapport",
        "modify_item": "Modifier l'élément",
        "copy_report_tooltip": "Copier le texte du rapport dans le presse-papiers",
        "copy_report": "Copier le rapport",
        "regenerate_report": "Régénérer le rapport",
        "report_actions": "Actions du rapport",
        "transcript_actions": "Actions de la transcription",
        "send_report": "Envoyer le rapport",
        "submit_report": "Envoyer le rapport à {{adapter}}",
        "confirm_edit": "Confirmer la modification",
        "delete": "Supprimer",
        "select_date_tooltip": "Sélectionner la date",
        "copy_error": "Erreur lors de la copie",
        "autosave_saving": "Enregistrement…",
        "autosave_saved": "Enregistré",
        "autosave_error": "Impossible d'enregistrer tes modifications",
        "send_report_tooltip": "Envoyer le rapport",
        "send_needs_ehr_template": "Ce modèle n'est pas lié à {{adapter}}. Choisis un modèle {{adapter}} pour envoyer le rapport.",
        "report_submitted_message": "Rapport envoyé avec succès à {{adapter}}",
        "recording_in_progress": "Enregistrement en cours. La transcription est mise à jour régulièrement et indique qui parle.",
        "next_update_in": "Prochaine mise à jour dans",
        "transcribing_last_audio": "Transcription du dernier audio...",
        "participant": "Participant",
        "identifying": "Identification du locuteur",
        "not_identified": "Participant non identifié",
        "ai_dialog_title": "Que puis-je ajuster pour vous ?",
        "ai_dialog_placeholder": "Saisissez ici ce que vous souhaitez ajuster...",
        "ai_dialog_input": "Instruction d'ajustement",
        "ai_dialog_start_recording": "Démarrer la saisie vocale",
        "ai_dialog_stop_recording": "Arrêter la saisie vocale",
        "mic_access_denied": "Accès au microphone refusé. Veuillez vérifier les paramètres de votre navigateur.",
        "transcription_error": "Une erreur s'est produite lors de la transcription de l'audio, veuillez réessayer.",
        "processing_transcription": "Traitement en cours...",
        "select_microphone": "Sélectionner un microphone",
        "microphone_label": "Microphone",
        "change_microphone_hint": "Arrête l'enregistrement pour changer de microphone.",
        "default_microphone": "Par défaut",
        "no_microphone_found": "Aucun microphone trouvé",
        "mic_permission": {
            "title": "Accès au microphone bloqué",
            "instruction": "L'accès au microphone pour ce site est bloqué. Suivez les étapes ci-dessous pour l'activer :",
            "step1": "Cliquez sur l'icône de cadenas à gauche de la barre d'adresse.",
            "step2": "Choisissez Paramètres du site.",
            "step3": "Recherchez Microphone dans la liste et définissez-le sur Autoriser.",
            "step4": "Rechargez cette page pour appliquer les paramètres.",
            "close": "Fermer"
        },
        "menu_groups": "Groupes",
        "live_translation": {
            "title": "Traduction en direct",
            "live": "En direct",
            "toggle": "Traduire en direct",
            "language_label_first": "Première langue",
            "language_label_second": "Deuxième langue",
            "start_recording": "Lance un enregistrement pour traduire en direct.",
            "original": "Original",
            "translated": "Traduit",
            "error_refused": "La traduction en direct a été refusée. Elle est peut-être déjà ouverte ailleurs ; ferme-la ou réessaie plus tard.",
            "error_unavailable": "La traduction en direct n'est pas disponible pour le moment. Désactive-la puis réactive-la pour réessayer.",
            "error_microphone": "La traduction en direct ne peut pas utiliser le micro dans ce navigateur."
        }
    },
    "chat": {
        "title": "Chat IA",
        "collapse": "Masquer le Chat IA",
        "expand": "Afficher le Chat IA",
        "expand_new_reply": "Afficher le Chat IA, nouvelle réponse",
        "replying": "Le Chat IA répond",
        "assistant_title": "Assistant",
        "busy_try_again": "Un instant. Je travaille encore sur ta dernière demande.",
        "copy_message": "Copier le message",
        "fullscreen": "Plein écran",
        "exit_fullscreen": "Quitter le plein écran",
        "dropzone_hint": "Dépose des fichiers ici pour les charger",
        "parsing_file": "Analyse du contenu du fichier...",
        "placeholder": "Pose une question à l'IA...",
        "attach_file": "Joindre un fichier",
        "send": "Envoyer",
        "disclaimer": "L'IA peut faire des erreurs. Consulte nos directives d'utilisation.",
        "action_create_report": "Génération du rapport",
        "action_modify_report": "Modification du rapport",
        "action_no_response": "Aucune réponse de l'assistant à ta demande",
        "action_create_report_running": "Création du rapport...",
        "action_create_report_done": "Rapport créé",
        "action_create_report_failed": "Rapport non créé",
        "action_modify_report_running": "Mise à jour du rapport...",
        "action_modify_report_done": "Rapport mis à jour",
        "action_modify_report_failed": "Rapport non mis à jour",
        "changed_sections": "Mis à jour : {{sections}}",
        "changed_nothing": "Le rapport est revenu inchangé",
        "tool_other_running": "Using a tool...",
        "tool_other_done": "Used a tool",
        "tool_other_failed": "A tool failed",
        "tool_status_running": "en cours",
        "tool_status_done": "terminé",
        "tool_status_failed": "échoué",
        "change_detected": "Consultation modifiée"
    },
    "auth": {
        "where_is_code_title": "Où se trouve mon code ?",
        "code_explain_1": "Pour vous connecter, vous avez besoin d'un code provenant d'une application d'authentification. Il s'agit d'une application sur votre téléphone qui génère un code de sécurité supplémentaire.",
        "most_used_apps": "Les applications les plus utilisées sont :",
        "google_authenticator": "Google Authenticator",
        "microsoft_authenticator": "Microsoft Authenticator",
        "find_code_in_app": "Recherchez l'une de ces applications sur votre téléphone et ouvrez-la. Vous verrez une liste avec un ou plusieurs comptes. Recherchez un code avec le nom medendo.",
        "enter_code": "Saisissez le code à côté de medendo pour continuer.",
        "no_code_contact": "Vous ne trouvez pas de code ? Veuillez contacter notre support. Vous trouverez un bouton de chat dans le coin inférieur droit. Cliquez dessus pour nous contacter.",
        "sign_up_with_google": "S'inscrire avec Google",
        "log_in_with_google": "Se connecter avec Google",
        "sign_up_with_microsoft": "S'inscrire avec Microsoft",
        "log_in_with_microsoft": "Se connecter avec Microsoft",
        "signin_failed": "La connexion n'est pas possible avec le compte sélectionné.",
        "no_account_found": "Aucun compte trouvé pour cet e-mail. Inscris-toi pour commencer.",
        "no_account_found_no_signup": "Aucun compte trouvé pour cet e-mail.",
        "password_setup": {
            "title": "Choisissez un nouveau mot de passe",
            "password_label": "Saisissez un nouveau mot de passe",
            "submit": "Définir le mot de passe",
            "reset_failed": "Échec de la réinitialisation de votre mot de passe.",
            "success_message": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
            "go_to_login": "Aller à la page de connexion"
        }
    },
    "history": {
        "retention_hint_one": "Supprimé {{count}} jour après la dernière modification",
        "retention_hint_other": "Supprimé {{count}} jours après la dernière modification",
        "sort_label": "Trier",
        "sort_newest": "Plus récents d'abord",
        "sort_oldest": "Plus anciens d'abord",
        "sort_expiring": "Expiration la plus proche",
        "sort_name": "Nom A-Z",
        "sort_template": "Modèle A-Z",
        "sort_client": "Client A-Z",
        "expires_in_one": "Expire dans {{count}} jour",
        "expires_in_other": "Expire dans {{count}} jours",
        "no_client": "Aucun client",
        "no_template": "Aucun modèle",
        "record_count_one": "{{count}} consultation",
        "record_count_other": "{{count}} consultations",
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "expires_today": "Expire aujourd'hui",
        "expires_tomorrow": "Expire demain",
        "search_placeholder": "Rechercher...",
        "no_results": "Aucune consultation ne correspond à ta recherche",
        "empty": "Aucune consultation pour l'instant",
        "column_patient": "Client",
        "column_template": "Modèle",
        "column_date": "Date",
        "column_available_until": "Disponible jusqu'au",
        "fetch_error": "Une erreur s'est produite lors de la récupération de l'historique.",
        "delete_confirm_title": "Supprimer la consultation ?",
        "delete_confirm": "Cette action est irréversible.",
        "delete": "Supprimer",
        "cancel": "Annuler",
        "delete_error": "Une erreur s'est produite lors de la suppression de la consultation.",
        "actions_tooltip": "Actions de la consultation",
        "offboarded_notice": "Ton compte est inactif, tu ne peux donc plus faire de nouveaux enregistrements. Tu peux encore lire les rapports et les transcriptions qui n'ont pas expiré. Regarde la date « Disponible jusqu'au ».",
        "renew_hint": "Tu veux enregistrer à nouveau ? Va dans Paramètres pour renouveler ton abonnement."
    },
    "admin": {
        "user_added_success": "Utilisateur ajouté avec succès.",
        "add_invalid_input": "L'adresse e-mail ou le nom est invalide.",
        "user_exists": "L'utilisateur existe déjà.",
        "add_failed": "Échec de l'ajout de l'utilisateur.",
        "user_updated_success": "Utilisateur mis à jour avec succès.",
        "user_update_failed": "Échec de la mise à jour de l'utilisateur.",
        "column_email": "E-mail",
        "column_permissions": "Autorisations",
        "column_status": "Statut",
        "select_all_on_page": "Tout sélectionner sur cette page",
        "previous_page": "Précédent",
        "next_page": "Suivant",
        "page_of": "Page {{page}} sur {{total}}",
        "add_user_title": "Ajouter un utilisateur",
        "email_label": "Adresse e-mail",
        "given_name_label": "Prénom",
        "family_name_label": "Nom de famille",
        "cancel": "Annuler",
        "add": "Ajouter",
        "domain_mismatch_warning": "Avertissement : le domaine de cette adresse e-mail diffère de ton domaine ({{domain}}).",
        "invalid_email_error": "Saisis une adresse e-mail valide",
        "user_already_exists_error": "Cet utilisateur existe déjà",
        "status_filter": "Statut",
        "permission_filter": "Autorisation",
        "all": "Tous",
        "status_active": "Actif",
        "status_inactive": "Inactif",
        "can_record": "Enregistrer",
        "can_template": "Modèles",
        "can_admin_templates": "Administration des modèles",
        "batch_onboard_btn": "Intégrer des utilisateurs",
        "batch_offboard_btn": "Désactiver des utilisateurs",
        "n_selected": "{{count}} sélectionné(s)",
        "delete_tooltip": "Supprimer",
        "clear_selection_tooltip": "Effacer la sélection",
        "batch_status_success": "Le statut de {{count}} utilisateur(s) a été changé en {{status}}.",
        "batch_status_error": "Erreur lors du changement de statut.",
        "batch_status_partial": "Certains utilisateurs n'ont pas pu être mis à jour.",
        "file_too_large_admin": "Le fichier est trop volumineux. La taille maximale est de 1 Mo.",
        "file_process_error": "Erreur lors du traitement du fichier. Réessaie.",
        "batch_onboard": "Intégration en lot",
        "batch_offboard": "Désactivation en lot",
        "batch_operation": "Opération en lot",
        "processing_file": "Traitement du fichier en cours... Cela peut prendre un moment.",
        "close": "Fermer",
        "no_users_in_file": "Aucun utilisateur trouvé dans le fichier.",
        "success_count": "Réussi : {{count}}",
        "failed_count": "Échoué : {{count}}",
        "confirm_n": "Confirmer ({{count}})",
        "retry_failed_n": "Réessayer les échecs ({{count}})",
        "batch_delete_title": "Confirmer la suppression",
        "batch_delete_content": "Tu es sur le point de supprimer <strong>{{count}}</strong> {{userText}}. Ils n'auront plus accès à Medendo. Es-tu sûr(e) de vouloir les supprimer ?",
        "batch_delete_user": "utilisateur",
        "batch_delete_users": "utilisateurs",
        "batch_delete_confirm": "Supprimer",
        "fetch_error": "Erreur lors de la récupération des utilisateurs.",
        "permissions_updated_success": "Autorisations mises à jour avec succès.",
        "permissions_update_error": "Erreur lors de la mise à jour des autorisations.",
        "user_deactivated_success": "Statut de l'utilisateur défini sur INACTIF.",
        "user_activated_success": "Utilisateur restauré en ACTIF.",
        "user_restore_error": "Erreur lors de la restauration de l'utilisateur.",
        "no_users_selected": "Aucun utilisateur sélectionné.",
        "user_not_found": "Utilisateur introuvable.",
        "unknown_error": "Erreur inconnue.",
        "batch_delete_success": "{{count}} utilisateur(s) supprimé(s).",
        "batch_delete_error": "Erreur lors de la suppression des utilisateurs.",
        "batch_delete_partial": "Certains utilisateurs sélectionnés n'ont pas pu être supprimés.",
        "batch_permissions_success": "{{count}} utilisateur(s) mis à jour.",
        "batch_permissions_error": "Erreur lors de la mise à jour des autorisations.",
        "batch_permissions_partial": "Certains utilisateurs n'ont pas pu être mis à jour.",
        "status_update_error": "Erreur lors de la mise à jour du statut de l'utilisateur.",
        "status_active_label": "ACTIF",
        "status_inactive_label": "INACTIF",
        "batch_onboard_server_error": "Une erreur s'est produite lors de l'ajout de l'utilisateur.",
        "can_org_admin": "Administrateur"
    },
    "settings": {
        "title": "Paramètres",
        "language_label": "Langue",
        "locale_update_error": "Échec de la mise à jour de la langue.",
        "preferences_title": "Préférences",
        "sounds_label": "Effets sonores",
        "analytics_api_key": {
            "title": "Clé API analytique",
            "info": "Utilisez cette clé pour vous authentifier auprès de l'API d'analyse d'utilisation de Medendo. La valeur complète n'est affichée qu'une seule fois lors de la première création de la clé ou juste après une rotation. La rotation remplace la clé actuelle par une nouvelle. L'ancienne clé est désactivée.",
            "active_label": "Clé active",
            "rotate": "Faire pivoter",
            "store_warning": "Enregistrez cette clé maintenant. Elle ne sera plus affichée.",
            "copy": "Copier",
            "copied": "Clé API analytique copiée dans le presse-papiers.",
            "copy_failed": "Échec de la copie de la clé API analytique.",
            "load_failed": "Échec du chargement du statut de la clé API analytique.",
            "action_failed": "L'action sur la clé API analytique a échoué.",
            "missing_error": "Aucune clé API analytique n'est configurée pour votre organisation. Veuillez contacter le support."
        },
        "your_groups": "Vos groupes",
        "your_groups_empty": "Vous n'êtes encore membre d'aucun groupe.",
        "account_title": "Compte",
        "status_label": "Statut",
        "status_inactive": "Inactif",
        "renew_explanation": "Ton abonnement est terminé, tu peux donc seulement lire ce que tu as déjà enregistré. Renouvelle-le pour enregistrer à nouveau.",
        "renew_button": "Renouveler l'abonnement",
        "renew_error": "Un problème est survenu au démarrage du renouvellement. Réessaie."
    },
    "offboard": {
        "title": "Désactiver l'utilisateur",
        "question": "Es-tu sûr(e) de vouloir désactiver cet utilisateur ?",
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "deleting": "Désactivation en cours..."
    },
    "templates": {
        "sort_favorites": "Favoris d'abord",
        "sort_name": "Nom A-Z",
        "sort_recent": "Modifiés récemment",
        "sort_author": "Auteur A-Z",
        "group_favorites": "Favoris",
        "group_all": "Tous les modèles",
        "template_count_one": "{{count}} modèle",
        "template_count_other": "{{count}} modèles",
        "new": "Nouveau",
        "list_label": "Modèles",
        "search_placeholder": "Rechercher...",
        "sort_label": "Trier",
        "share_header": "Partager",
        "description_header": "Description",
        "owner_header": "Propriétaire",
        "favorite_tooltip": "Les modèles ajoutés aux favoris s'affichent en premier lors de la sélection d'un modèle pour un enregistrement.",
        "shared_with_org": "Partagé avec l'organisation",
        "not_shared": "Non partagé",
        "manager": {
            "copy_suffix": " (copie)",
            "imported_suffix": " (importé)",
            "default_imported_name": "Modèle importé"
        },
        "copy_tooltip": "Copier",
        "download_tooltip": "Télécharger",
        "edit_tooltip": "Modifier",
        "delete_tooltip": "Supprimer",
        "delete_confirm_button": "Supprimer",
        "delete_confirm_title": "Supprimer le modèle ?",
        "delete_confirm": "Cette action est irréversible.",
        "cancel": "Annuler",
        "read_file_error": "Impossible de lire le contenu du fichier.",
        "import_success": "Modèle importé avec succès.",
        "import_invalid": "Erreur lors de l'importation du modèle. Est-ce un fichier JSON valide ?",
        "create_dialog": {
            "title": "Choisissez une façon de créer un modèle",
            "wizard": "Assistant de modèle",
            "import": "Importer",
            "library": "Bibliothèque",
            "manual": "Manuel",
            "library_description": "Choisissez autant de modèles que vous le souhaitez dans notre bibliothèque comme point de départ.<br/><br/>Vous pouvez expérimenter avec ces modèles pour voir comment fonctionne l'espace de travail Medendo, puis les adapter facilement à vos besoins et intérêts spécifiques.",
            "library_button": "Choisir dans la bibliothèque",
            "wizard_description": "Chargez un exemple de rapport complété tel que vous le rédigeriez après une conversation avec un client. Fichiers pris en charge : .docx, .pdf, .txt.<br/><br/>L'IA le convertit en un modèle que vous pouvez utiliser dans Medendo. Vérifiez l'anonymat.",
            "wizard_button": "Charger un exemple",
            "import_description": "Importez un modèle existant depuis un fichier .json.",
            "import_button": "Charger un .json",
            "manual_description": "Vous pouvez également commencer avec un modèle vide.<br/><br/>Choisissez cette option si vous n'avez pas de bon exemple de document ou si vous ne souhaitez pas utiliser l'IA.",
            "manual_button": "Créer vous-même",
            "cancel": "Annuler"
        },
        "library": {
            "back": "Retour",
            "title": "Bibliothèque de modèles",
            "description": "Cette bibliothèque est une collection de modèles courants provenant de diverses disciplines de santé. Si vous voyez un modèle que vous souhaitez utiliser, vous pouvez cliquer sur le bouton « ajouter » pour le rendre disponible dans votre compte. Une fois le modèle dans votre compte, vous pouvez également le modifier librement.",
            "tabs": {
                "external": "Externe"
            },
            "search_placeholder": "Rechercher dans la bibliothèque...",
            "locale_filter_all": "Toutes les langues",
            "language_label": "Langue",
            "table": {
                "template": "Modèle",
                "description": "Description",
                "actions": "Actions"
            },
            "actions": {
                "add": "Ajouter",
                "add_tooltip": "Ajouter ce modèle à votre collection",
                "in_templates": "Dans vos modèles",
                "import_success": "Modèle « {{name}} » ajouté avec succès.",
                "import_error": "Une erreur s'est produite lors de l'importation du modèle",
                "fetch_error": "Une erreur s'est produite lors de la récupération de la bibliothèque de modèles."
            }
        },
        "external_library": {
            "search_placeholder": "Rechercher dans la bibliothèque {{adapter}}...",
            "search_placeholder_default": "adaptateur",
            "table": {
                "template": "Modèle",
                "description": "Description",
                "actions": "Actions"
            },
            "actions": {
                "add": "Ajouter",
                "add_tooltip": "Ajouter ce modèle à votre collection",
                "in_templates": "Dans vos modèles",
                "import_success": "Modèle « {{name}} » ajouté avec succès.",
                "import_error": "Une erreur s'est produite lors de l'importation du modèle"
            }
        },
        "view": {
            "back": "Retour",
            "download": "Télécharger",
            "edit": "Modifier",
            "name": "Nom :",
            "description": "Description :",
            "no_description": "Aucune description disponible",
            "items": "Éléments :",
            "no_description_fallback": "Aucune description",
            "no_examples_fallback": "Aucun exemple"
        },
        "edit": {
            "back": "Retour",
            "sync": "Synchroniser avec l'EHR",
            "save": "Enregistrer",
            "name_label": "Nom",
            "description_label": "Description",
            "keywords_label": "Mots-clés",
            "keywords_info": "Ajoutez des termes médicaux, des noms ou du jargon difficiles à transcrire. Ils sont transmis au moteur de reconnaissance vocale pour améliorer la précision de la transcription pour ce modèle.",
            "keywords_placeholder": "ex. quétiapine, sertraline, méthylphénidate : sépare par des espaces, des virgules, des points ou des sauts de ligne",
            "items_header": "Éléments :",
            "add_item": "Ajouter un nouvel élément",
            "item_name": "Nom",
            "item_type": "Type",
            "item_default_value": "Texte par défaut",
            "note_hint": "Ce texte apparaîtra dans le rapport tel quel. L'IA ne le modifiera pas.",
            "item_description": "Description",
            "item_examples": "Exemples",
            "delete_item_tooltip": "Supprimer l'élément",
            "copy_item_tooltip": "Copier l'élément",
            "move_up_tooltip": "Déplacer vers le haut",
            "move_down_tooltip": "Déplacer vers le bas",
            "copy_suffix": " (copie)",
            "sync_success": "{{count}} nouveaux éléments ajoutés",
            "sync_updated": "Modèle synchronisé",
            "sync_updated_with_items": "Modèle synchronisé, {{count}} nouveaux éléments ajoutés",
            "sync_up_to_date": "Le modèle est déjà à jour",
            "sync_error": "Erreur lors de la synchronisation du modèle.",
            "magic_wand": "Modifier le modèle",
            "magic_wand_tooltip": "Décris ce que tu veux changer et l'IA adaptera le modèle",
            "modifying_ai": "L'IA adapte le modèle…",
            "modify_success": "L'IA a adapté le modèle",
            "modify_error": "Erreur lors de la modification du modèle.",
            "save_error_no_name": "Donne un nom au modèle.",
            "save_error_no_items": "Ajoute au moins un élément.",
            "save_success_updated": "Modèle mis à jour avec succès",
            "save_success_created": "Modèle créé avec succès",
            "save_error_generic": "Erreur lors de l'enregistrement du modèle.",
            "default_description": "Un rapport chronologique de la conversation avec le client, le patient et/ou d'autres personnes sous forme narrative.",
            "types": {
                "text": "Texte",
                "number": "Nombre",
                "date": "Date",
                "checkbox": "Case à cocher",
                "radiobutton": "Bouton radio",
                "checkbox_group": "Groupe de cases à cocher",
                "note": "Note"
            },
            "options_label": "Options",
            "add_option": "Ajouter une option",
            "option_placeholder": "Option",
            "duplicate_option": "Cette option existe déjà"
        },
        "share_dialog": {
            "title": "Partager le modèle ?",
            "content": "Êtes-vous sûr(e) de vouloir partager « {{templateName}} » avec le groupe « {{groupName}} » ?",
            "cancel": "Annuler",
            "confirm": "Partager"
        },
        "unshare_dialog": {
            "title": "Arrêter le partage ?",
            "content": "Êtes-vous sûr(e) de vouloir arrêter de partager « {{templateName}} » avec le groupe « {{groupName}} » ?",
            "cancel": "Annuler",
            "confirm": "Arrêter le partage"
        },
        "wizard_loading": {
            "elapsed_time": "Temps écoulé : {{time}}",
            "please_wait": "Quelques minutes de patience, s'il vous plaît...",
            "messages": [
                "Chargement du fichier...",
                "Lecture du document...",
                "Analyse du contenu...",
                "Génération du modèle...",
                "Presque prêt..."
            ]
        },
        "created_by": "Créé par {{creator}}",
        "modified_ago": "modifié {{time}}",
        "created_modified_tooltip": "Créé {{created}} · dernière modification {{modified}}",
        "created_date": "Créé {{date}}",
        "author_header": "Auteur",
        "shared_with_header": "Partagé avec",
        "modified_header": "Modifié",
        "author_you": "Vous",
        "admins_only": "admins uniquement",
        "no_results": "Aucun modèle ne correspond à votre recherche.",
        "n_groups": "{{count}} groupes",
        "actions_tooltip": "Actions du modèle",
        "share_manage": {
            "title": "Gérer le partage",
            "not_shared": "Non partagé",
            "all_members": "Tous les membres",
            "admins_only": "Administrateurs uniquement",
            "no_rights": "Vous n'avez de droits de partage dans aucun groupe. Les administrateurs et administrateurs de modèles peuvent partager des modèles.",
            "private_summary": "Ce modèle est privé.",
            "shared_summary_one": "Partagé avec {{count}} groupe.",
            "shared_summary_other": "Partagé avec {{count}} groupes.",
            "cancel": "Annuler",
            "save": "Enregistrer"
        }
    },
    "adapter": {
        "connection_error": "{{adapter}} est temporairement indisponible. Réessaie plus tard.",
        "reconnected": "Reconnexion à {{adapter}} réussie.",
        "reconnect_required": "Ta session {{adapter}} a expiré. Reconnecte-toi.",
        "reconnect_failed": "Impossible de se reconnecter à {{adapter}}. Reconnecte-toi depuis Intégrations.",
        "fetch_templates_error": "Impossible de charger les modèles depuis {{adapter}}.",
        "fetch_patients_error": "Impossible de charger les clients depuis {{adapter}}.",
        "required_fields_one": "Le champ {{fields}} est obligatoire et doit être rempli.",
        "required_fields_other": "Les champs {{fields}} sont obligatoires et doivent être remplis."
    },
    "integrations": {
        "load_error": "Impossible de charger les intégrations",
        "init_error": "Impossible de démarrer la connexion",
        "launch": {
            "session_expired": "Session expirée. Veuillez rouvrir Medendo depuis votre DSE.",
            "config_error": "Impossible d'établir la session DSE. Veuillez contacter le support."
        },
        "disconnect_confirm_title": "Déconnecter {{adapter}} ?",
        "disconnect_confirm": "Tu pourras te reconnecter à tout moment.",
        "cancel": "Annuler",
        "disconnect_success": "Connexion déconnectée",
        "disconnect_error": "Impossible de se déconnecter",
        "connected": "Connecté",
        "not_connected": "Non connecté",
        "disconnect_btn": "Déconnecter",
        "connect_btn": "Connecter",
        "callback": {
            "invalid_parameters": "Paramètres de rappel invalides",
            "success": "Intégration connectée avec succès !",
            "error": "Impossible de finaliser l'intégration",
            "redirecting": "Vous êtes redirigé(e) vers la page des intégrations...",
            "connecting": "Connexion de l'intégration...",
            "please_wait": "Veuillez patienter pendant la configuration de votre intégration."
        }
    },
    "errors": {
        "create_encounter": "Une erreur s'est produite lors de la création de la consultation.",
        "update_encounter": "Une erreur s'est produite lors de la mise à jour de la consultation.",
        "client_locked": "Le client ne peut plus être modifié : l'assistant a déjà récupéré son historique.",
        "generate_report": "Une erreur s'est produite lors de la génération du rapport.",
        "generate_transcript": "Une erreur s'est produite lors de la génération de la transcription.",
        "update_field": "Une erreur s'est produite lors de la mise à jour du champ.",
        "upload_file": "Une erreur s'est produite lors du chargement du fichier.",
        "delete_file": "Une erreur s'est produite lors de la suppression du fichier.",
        "send_message": "Une erreur s'est produite lors de l'envoi du message.",
        "submit_report": "Une erreur s'est produite lors de l'envoi du rapport.",
        "fetch_templates": "Une erreur s'est produite lors de la récupération des modèles.",
        "fetch_groups": "Une erreur s'est produite lors de la récupération des groupes.",
        "copy_template": "Une erreur s'est produite lors de la copie du modèle.",
        "share_template": "Une erreur s'est produite lors du partage du modèle.",
        "unshare_template": "Une erreur s'est produite lors de l'annulation du partage du modèle.",
        "delete_template": "Une erreur s'est produite lors de la suppression du modèle.",
        "logout": "Une erreur s'est produite lors de la déconnexion.",
        "user_info": "Une erreur s'est produite lors de la récupération des informations utilisateur.",
        "not_found_encounter": "La consultation est introuvable.",
        "azure_policy_violation": "La modification a échoué en raison de la politique de contenu Azure OpenAI. Veuillez réessayer. Si l'échec persiste, contactez le support.",
        "restricted_browser_environment": "Il semble que vous ayez ouvert notre application dans un environnement de navigateur restreint. Veuillez ouvrir l'application dans votre navigateur.",
        "item_missing_in_template": "L'élément sélectionné est absent du modèle et ne peut pas être modifié (le modèle a peut-être changé).",
        "file_too_large": "Le fichier « {{name}} » est trop volumineux. Il ne doit pas dépasser {{maxMb}} Mo.",
        "upload_success": "Fichier « {{name}} » chargé avec succès.",
        "process_file_problem": "Un problème s'est produit lors du traitement de « {{name}} ».",
        "template_not_found": "Le modèle demandé ({{id}}) n'est pas disponible pour toi. Contacte la personne responsable de la connexion avec le système Medendo.",
        "patient_not_found": "Le client issu du lancement ({{id}}) n'est pas disponible pour toi. Contacte la personne responsable de la connexion avec le système Medendo.",
        "update_favorite_failed": "Échec de la mise à jour du statut de favori.",
        "template_shared": "Modèle « {{name}} » partagé avec succès.",
        "template_unshared": "Le partage du modèle « {{name}} » a été annulé.",
        "template_deleted": "Modèle supprimé avec succès.",
        "copy_success": "Modèle copié avec succès.",
        "file_deleted_success": "Fichier « {{name}} » supprimé avec succès.",
        "process_file_delete_problem": "Un problème s'est produit lors de la suppression de « {{name}} ».",
        "unauthorized_refresh": "Requête non autorisée. Tentative de renouvellement du jeton...",
        "error_page": {
            "title": "Oups ! Une erreur s'est produite.",
            "default_message": "La page que tu recherches est introuvable ou une autre erreur s'est produite.",
            "unexpected_message": "Une erreur inattendue s'est produite. Retourne à la page d'accueil et réessaie.",
            "back_home": "Retour à la page d'accueil"
        },
        "sharing_updated": "Partage mis à jour.",
        "update_sharing": "Une erreur s’est produite lors de la mise à jour du partage."
    },
    "privacy_policy": {
        "title": "Déclaration de confidentialité de Medendo",
        "agree_checkbox": "J'accepte la déclaration de confidentialité",
        "agree_button": "Accepter"
    },
    "usage_instructions": {
        "title": "Instructions pour une utilisation responsable de Medendo",
        "agree_checkbox": "J'ai lu et compris les instructions générales",
        "agree_button": "Accepter"
    },
    "user_agreement": {
        "title": "Conditions générales d'utilisation de Medendo",
        "agree_checkbox": "J'accepte les Conditions Générales d'Utilisation",
        "agree_button": "Accepter"
    },
    "groups": {
        "title": "Groupes",
        "create_title": "Créer un groupe",
        "name_label": "Nom du groupe",
        "description_label": "Description (optionnelle)",
        "create_admin_note": "Vous serez le premier administrateur du groupe. Ajoutez des membres et partagez des templates une fois qu'il est créé.",
        "create": "Créer",
        "cancel": "Annuler",
        "create_error": "Une erreur s’est produite lors de la création du groupe.",
        "created": "Groupe « {{name}} » créé.",
        "no_groups": "Aucun groupe disponible.",
        "no_users_found": "Aucun utilisateur trouvé.",
        "search_more_hint": "Affichage des {{count}} premiers résultats. Affinez votre recherche pour en voir davantage.",
        "tab_templates": "Modèles",
        "template_visibility_group": "Tous les membres",
        "template_visibility_admin": "Administrateurs du groupe",
        "template_visibility_private": "Privé",
        "no_templates": "Aucun modèle partagé avec ce groupe pour l’instant.",
        "description": "Équipes de votre organisation qui partagent des modèles.",
        "search_placeholder": "Rechercher des groupes…",
        "search_members_placeholder": "Rechercher des membres…",
        "all_groups": "Tous les groupes",
        "new_group": "Nouveau groupe",
        "scope_group_admins_hint": "Visible uniquement par les administrateurs du groupe.",
        "view_only_hint": "Vous pouvez consulter les membres de ce groupe. La modification est réservée aux administrateurs de groupe et d’organisation.",
        "member_role_admin": "Administrateur",
        "member_role_member": "Membre",
        "add_member": "Ajouter un membre",
        "add_member_title": "Ajouter un membre",
        "add_member_search_label": "Rechercher un utilisateur",
        "add": "Ajouter",
        "no_members": "Aucun membre dans ce groupe.",
        "fetch_members_error": "Une erreur s’est produite lors de la récupération des membres.",
        "add_member_error": "Une erreur s’est produite lors de l'ajout du membre.",
        "remove_member_error": "Une erreur s’est produite lors de la suppression du membre.",
        "update_member_error": "Une erreur s’est produite lors de la mise à jour du membre.",
        "member_added": "Membre ajouté.",
        "member_removed": "Membre supprimé.",
        "member_updated": "Autorisations du membre mises à jour.",
        "scope_change_tooltip": "Modifier la visibilité",
        "open_template_tooltip": "Ouvrir le modèle",
        "integration_tooltip": "Appartient à l'intégration {{name}}",
        "member_actions_tooltip": "Actions du membre",
        "remove_from_group": "Retirer du groupe",
        "deleted": "Groupe supprimé.",
        "delete_error": "Une erreur s’est produite lors de la suppression du groupe.",
        "edit_title": "Modifier le groupe",
        "save_changes": "Enregistrer les modifications",
        "edit_hint": "Les membres et les modèles ne sont pas affectés : uniquement l'apparence du groupe.",
        "updated": "Détails du groupe mis à jour.",
        "update_error": "Une erreur s’est produite lors de la mise à jour du groupe.",
        "add_member_note": "Les nouveaux membres rejoignent en tant que Membre. Seul un administrateur d’organisation peut faire de quelqu’un un administrateur de groupe.",
        "member_you": "vous",
        "delete_dialog_title": "Supprimer le groupe '{{name}}' ?",
        "delete_body": "Les templates assignés deviendront privés pour leurs propriétaires. Cette action est irréversible.",
        "delete_affected_one": "1 template partagé et {{memberCount}} adhésions seront affectés.",
        "delete_affected_other": "{{count}} templates partagés et {{memberCount}} adhésions seront affectés.",
        "delete_confirm_button": "Supprimer le groupe",
        "n_shared_one": "1 template partagé",
        "n_shared_other": "{{count}} templates partagés",
        "private_templates_section": "Vos templates privés",
        "members_section_title": "Membres",
        "edit_action": "Modifier",
        "n_members_one": "1 membre",
        "n_members_other": "{{count}} membres",
        "n_admins_one": "1 administrateur",
        "n_admins_other": "{{count}} administrateurs",
        "n_template_admins_one": "1 admin de modèles",
        "n_template_admins_other": "{{count}} admins de modèles",
        "role_template_admin": "Admin de modèles",
        "make_admin": "Nommer administrateur",
        "make_template_admin": "Nommer admin de modèles",
        "make_member": "Définir le rôle sur Membre",
        "set_role_admin_title": "Nommer administrateur ?",
        "set_role_admin_body": "La personne pourra ajouter ou retirer des membres, définir les rôles et gérer le partage des templates de ce groupe.",
        "set_role_admin_confirm": "Nommer administrateur",
        "set_role_template_admin_title": "Nommer admin de modèles ?",
        "set_role_template_admin_body": "La personne pourra partager et retirer des templates avec ce groupe, en plus de l'adhésion normale.",
        "set_role_template_admin_confirm": "Nommer admin de modèles",
        "set_role_member_title": "Définir comme membre ?",
        "set_role_member_body": "La personne conserve son adhésion mais peut uniquement consulter le groupe et ses templates partagés.",
        "set_role_member_confirm": "Définir comme membre",
        "no_matches": "Aucune correspondance",
        "no_results": "Aucun résultat"
    }
}
